import axios from 'axios';
import authService from 'services/auth.service';

axios.interceptors.request.use(
    (config) => {
        var token = localStorage.getItem('admin-token');
        // if (token && config.url != "/oauth/token" && config.url.indexOf(process.env.REACT_APP_S3_DOWNLOAD_BUCKET) < 0) {
        if (token && config.url != '/oauth/token') {
            let tokenObj = JSON.parse(token);
            config.headers['Authorization'] = `Bearer ${tokenObj.access_token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

axios.interceptors.response.use(
    (response) => {
        // 새로고침될때 response.data 가 않오고 response 로 오는 경우
        return response.data ? response.data : response;
    },
    async (error) => {
        const originalRequest = error.config;

        if (error.code == 'ERR_CANCELED') {
            return Promise.reject(error);
        }

        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                let data = await authService.refreshToken();

                let token = data;

                originalRequest.headers['Authorization'] = `Bearer ${token.access_token}`;

                return axios(originalRequest);
            } catch (error) {
                authService.signOut();
            }
        }

        return Promise.reject(error);
    },
);

export default axios;
